module.exports = {"title":"Credit Card Information","payWithCard":"Pay with card - FR","name":"ShowTix4U - FR"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/PayWithCard/locales/fr.json
// module id = 1189
// module chunks = 0